/* eslint-disable check-file/filename-blocklist */
import React from 'react';

import { EDITOR_MODE } from '../CommentsSection/helpers/constants';

export function getComments(comments, props, genericProps, Component) {
	const {
		focusOnCommentId,
		highlightedComments,
		autoFocusedCommentId,
		newComments,
		onCommentAutoFocused,
		userInfo,
	} = props;

	const { editor } = genericProps;

	const elements = [];

	const idSet = new Set();

	comments.forEach((comment) => {
		if (idSet.has(comment.id)) {
			return;
		}
		idSet.add(comment.id);

		const props = {
			...genericProps,
			comment,
			userInfo: comment.createdBy,
			isFocused: focusOnCommentId === comment.id,
			isHighlighted:
				highlightedComments.indexOf(comment.id) > -1 ||
				// Highlight newly created comments for users to see
				newComments.indexOf(comment.id) > -1,
			shouldAutofocus: autoFocusedCommentId === comment.id,
			onAutoFocused: onCommentAutoFocused,
			mode: editor.commentId === comment.id && editor.mode === EDITOR_MODE.EDIT ? 'edit' : 'view',
			currentUserAccountId: userInfo.accountId,
		};

		elements.push(<Component key={comment.id} {...props} />);

		if (editor.commentId === comment.id && editor.mode === EDITOR_MODE.REPLY) {
			const replyProps = {
				...genericProps,
				userInfo,
				mode: 'edit',
				isEditorEnabled: true,
				comment: {
					id: comment.id,
					depthLevel: comment.depthLevel + 1,
				},
			};
			elements.push(<Component key={`${comment.id}-reply`} {...replyProps} />);
		}
	});
	return elements;
}
